import * as React from 'react';
import { Dropdown, DropdownProps } from 'primereact/dropdown';
import styles from './NewDropdown.module.css';


export const NewDropdown: React.FC<DropdownProps> = ({ className, panelClassName, ...rest }) => (
  <Dropdown
    className={[styles.dropdown, className].filter(Boolean).join(' ')}
    panelClassName={[styles.panel, panelClassName].filter(Boolean).join(' ')}
    {...rest}
  />
);
